import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';



@NgModule({
  imports: [RouterModule.forChild([
    { path: '', loadChildren: () => import('./comanda-inserir/comanda-inserir.module').then(m => m.ComandaInserirModule) },
    { path: 'detalhar', data: { breadcrumb : 'Detalhar' }, loadChildren: () => import('./comanda-detalhar/comanda-detalhar.module').then(m => m.ComandaDetalharModule) },

  ])],
  exports: [RouterModule]
})
export class ComandaRoutingModule { }
